import React, { useState } from "react"
import { SeoContext } from "app/context/useSeo"


export const SeoProvider = ({ children } : {children : React.ReactNode}) => {
    const [h1, setHeading] = useState('')
    const setH1 = (title: string) => setHeading(title)
    return (
        <SeoContext.Provider value={{h1, setH1}}>
            { children }
        </SeoContext.Provider>
    )
}